export const TITLE = 'Logto';
export const COLOR_PRIMARY = '#7C47FE';
